const Search = () => {
    return <svg xmlns='http://www.w3.org/2000/svg' width='24.059' height='24.063' viewBox='0 0 24.059 24.063'>
        <path id='Icon_awesome-search' data-name='Icon awesome-search' d='M23.731,20.8l-4.685-4.685a1.127,1.127,0,0,0-.8-.329h-.766a9.77,9.77,0,1,0-1.692,1.692v.766a1.127,1.127,0,0,0,.329.8L20.8,23.731a1.123,1.123,0,0,0,1.593,0l1.33-1.33a1.133,1.133,0,0,0,0-1.6ZM9.775,15.79A6.015,6.015,0,1,1,15.79,9.775,6.012,6.012,0,0,1,9.775,15.79Z' fill='#dadada' />
    </svg>
}

export default Search